import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';
import formatTimestamp from '../../common/formatTimestamp';
import DescriptionBox from '../common/DescriptionBox';
import type {GlobalJob} from '../types';
import '../types';
import './JobDetailsDetails.less';
import './GlobalJobDetails.less';
import {extractEmail} from '../utils';
import useGetUserByAccountNumber from '../hooks/useGetUserByAccountNumber';
import Blacklist from '../Blacklist';
type Props = {
	job: GlobalJob;
};

const GlobalJobDetails = ({job: {latestExecutionDate, createdAt, createdBy, description, blacklistIds}}: Props) => {
	const {loading, user} = useGetUserByAccountNumber(createdBy);
	const userEmail = extractEmail(user);
	return (
		<div className="di job-details-details global">
			<h2 className="di header dividing">
				<Trans i18nKey="globaljobs.details.form">Global Job Details</Trans>
			</h2>
			<SpinnerContainer show={loading}>
				<div className="di job-details">
					<div className="field latest-execution-date">
						<label>
							<Trans i18nKey="updatejobs.details.latestExecutionDate">Latest Execution date</Trans>
						</label>
						<div>{formatTimestamp(latestExecutionDate)}</div>
					</div>
					<div className="field created-at-date">
						<label>
							<Trans i18nKey="globaljobs.details.createdAtDate">Global Job created on</Trans>
						</label>
						<div>{formatTimestamp(createdAt)}</div>
					</div>
					{user && (
						<div className="field created-by">
							<label>
								<Trans i18nKey="globaljobs.details.createdBy">Global Job created by</Trans>
							</label>
							<div>{userEmail ? <a href={`mailto:${userEmail}`}>{userEmail}</a> : user.name}</div>
						</div>
					)}
					{description && (
						<div className="description">
							<label>
								<Trans i18nKey="globaljobs.details.description">Description</Trans>
							</label>
							<DescriptionBox description={description} showDefault={false} />
						</div>
					)}
					<div className="blacklisted-tenants">
						<Blacklist
							show={true}
							blacklistIds={blacklistIds}
							label={{
								i18nKey: 'globaljobs.details.blacklist',
								defaultValue: 'The following customers were excluded from the update'
							}}
						/>
					</div>
				</div>
			</SpinnerContainer>
		</div>
	);
};

export default GlobalJobDetails;
